<script setup lang="ts">
import CarouselPreviousBase from '@/components/lib/shadcn-vue/carousel/CarouselPreviousBase.vue';
import { useCarousel } from '@/components/lib/shadcn-vue/carousel/useCarousel';

const { orientation, canScrollPrev, scrollPrev } = useCarousel();

const onClickScrollPrev = (e: MouseEvent) => {
  e.preventDefault();
  // カード全体がリンクの一覧では、伝播させるとカードのクリックとして遷移・計測されてしまう
  e.stopPropagation();
  scrollPrev();
};
</script>

<template>
  <CarouselPreviousBase :can-scroll-prev="canScrollPrev" :on-click-scroll-prev="onClickScrollPrev" :orientation="orientation" />
</template>
